"use client";
import { University } from "@/store/types/aiCourseFinder";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Calender, EducationCap, Fee, TimeClock } from "./Icons";
import { ImageBackground } from "./ImageBackground";

interface CountryUniCardsProps {
  items: University;
}

export default function CountryUniCard({ items }: CountryUniCardsProps) {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    setIsTouchDevice(isTouch);
    1;
  }, []);

  return (
    <div className="relative w-full h-full">
      {isTouchDevice ? (
        <Link
          href={`/${items.college_slug}`}
          className="relative w-full h-full rounded-[24px] group border border-[#B088F9] overflow-hidden shadow-md flex-col flex"
        >
          <div className="w-full max-h-[170px] md:max-h-[220px] xl:max-h-[270px] h-full relative">
            <span className="rounded-l-xl w-full h-full object-cover object-center">
              <ImageBackground
                college_name={items.college_name ?? ""}
                country={items.address_info.country ?? ""}
              />
            </span>
          </div>

          <span className="absolute bottom-0 left-0 w-full h-[100%] lg:h-[94%] ">
            <Image
              className="w-full h-full"
              src="/assets/images/png/cardBannerMobile.png"
              alt="University Logo"
              width={742}
              height={420}
            />
          </span>
          <div className="relative flex flex-col items-center justify-center gap-y-[0px] gap-x-[36px] w-full h-full">
            <p className="font-semibold text-[18px] sm:text-[20px] lg:text-[22px] 2xl:text-[24px] 3xl:text-[26px] mb-[20px] xl:mb-[30px] text-center px-4">
              {items?.college_name}
            </p>
            <div className="grid-cols-2 grid gap-y-[20px] 2xl:gap-y-[56px] gap-x-[20px] lg:gap-x-[60px] 2xl:gap-x-[96px]  px-5 pb-[100px]">
              <div className="flex items-center gap-3 w-auto">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full">
                  <EducationCap color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black">
                    Founded in
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1 capitalize">
                    {items.founded_year ? items?.founded_year : "N/A"}
                  </p>
                </div>
              </div>
              <div className="flex items-center w-auto max-w-[160px] gap-3 ">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full">
                  <Calender color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black">
                    Category
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1 capitalize">
                    {items.category ? items?.category : "N/A"}
                  </p>
                </div>
              </div>{" "}
              <div className="flex items-center w-auto gap-3">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full">
                  <Fee color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black">
                    Application Fees
                  </p>

                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs xl:text-[14px] 3xl:text-base leading-[18px] xl:leading-[24px]">
                    {Number(items.application_fees) === 0 ? (
                      <span>No Application Fee</span>
                    ) : items.currency === "GBP" &&
                      Number(items.application_fees) > 0 ? (
                      <span className="relative before:absolute before:w-full before:h-[2px] before:bg-red-600 before:top-1/2 before:-translate-y-1/2 before:left-0 before:rotate-[3deg]">
                        {`${items.currency} ${String(items.application_fees).replace(".00", "")}`}
                        <span className="absolute text-pink-500 top-full left-0 text-nowrap text-xs">
                          Fees Waived Off
                        </span>
                      </span>
                    ) : Number(items.application_fees) > 0 ? (
                      `${items.currency || ""} ${String(items.application_fees).replace(".00", "")}`
                    ) : (
                      "Not Announced"
                    )}
                  </p>
                </div>
              </div>
              <div className="flex items-center w-auto  max-w-[160px] gap-3 ">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full inline-block">
                  <TimeClock color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black ">
                    Offer TAT
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1">
                    {items.offer_tat ? items?.offer_tat : "N/A"} Days
                  </p>
                </div>
              </div>
            </div>
            <Link
              href={`/${items.college_slug}`}
              className="font-semibold cursor-pointer ff_poppins text-sm xl:text-base 3xl:text-lg rounded-xl text-center hover:scale-105 ease-linear duration-300 mt-6 absolute bottom-8 sm:bottom-7 lg:bottom-10 left-1/2 -translate-x-1/2 text-nowrap"
            >
              <span className="gradientBorderWithRadios px-6 sm:px-7 lg:px-10 xl:px-12 py-[14px] sm:py-3">
                Explore Courses
              </span>
            </Link>
          </div>
        </Link>
      ) : (
        <Link
          href={`/${items.college_slug}`}
          className="relative w-full h-full rounded-[24px] group border border-[#B088F9] overflow-hidden shadow-md flex-col flex"
        >
          <span className="rounded-l-xl w-full h-full object-cover object-center">
            <ImageBackground
              college_name={items.college_name ?? ""}
              country={items.address_info.country ?? ""}
            />
          </span>

          {/* Right - White Section with Text */}
          <span className="hidden xl:block absolute w-full xl:w-[100%] 2xl:w-[100%] h-[130%] 2xl:h-full group-hover:h-[750%] bottom-0 right-0 duration-300 ease-in-out">
            <Image
              className="w-full h-full"
              src="/assets/images/png/cardHoverElement.png"
              alt="University Logo"
              width={742}
              height={420}
            />
          </span>
          <span className="absolute bottom-0 left-0 w-full h-[80%] md:h-[80%] xl:h-[90%] xl:hidden">
            <Image
              className="w-full h-full"
              src="/assets/images/png/cardBannerMobile.png"
              alt="University Logo"
              width={742}
              height={420}
            />
          </span>
          <div className="xl:absolute relative xl:group-hover:top-0 xl:top-[100%] xl:right-1/2 flex flex-col xl:translate-x-1/2 items-center justify-center gap-y-[0px] gap-x-[36px] group-hover:opacity-100 xl:opacity-0 duration-300 ease-in-out  w-full h-full ">
            <p className="font-semibold text-[18px] mb-[26px] xl:hidden text-center">
              {items?.college_name}
            </p>
            <div className="grid-cols-2 grid gap-y-[20px] 2xl:gap-y-[56px] gap-x-[20px] lg:gap-x-[60px] 2xl:gap-x-[96px] pb-14 px-5">
              <div className="flex items-center gap-3 w-auto">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full">
                  <EducationCap color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black">
                    Founded in
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1 capitalize">
                    {items.founded_year ? items.founded_year : "N/A"}
                  </p>
                </div>
              </div>
              <div className="flex items-center w-auto max-w-[160px] gap-3 ">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full">
                  <Calender color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black">
                    Category
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1 capitalize">
                    {items.category ? items.category : "N/A"}
                  </p>
                </div>
              </div>{" "}
              <div className="flex items-center w-auto gap-3">
                <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full">
                  <Fee color="#505050" />
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black">
                    Application Fees
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1 capitalize">
                    {Number(items.application_fees) === 0 ? (
                      <span>No Application Fee</span>
                    ) : items.currency === "GBP" &&
                      Number(items.application_fees) > 0 ? (
                      <span className="relative before:absolute before:w-full before:h-[2px] before:bg-red-600 before:top-1/2 before:-translate-y-1/2 before:left-0 before:rotate-[3deg]">
                        {`${items.currency} ${String(items.application_fees).replace(".00", "")}`}
                        <span className="absolute text-pink-500 top-full left-0 text-nowrap text-xs">
                          Fees Waived Off
                        </span>
                      </span>
                    ) : Number(items.application_fees) > 0 ? (
                      `${items.currency || ""} ${String(items.application_fees).replace(".00", "")}`
                    ) : (
                      "Not Announced"
                    )}
                  </p>
                </div>
              </div>
              <div className="flex items-center w-auto  max-w-[160px] gap-3 ">
                <span className="max-w-[36px]">
                  <span className="max-w-[24px] sm:max-w-[30px] xl:max-w-[36px] w-full inline-block">
                    <TimeClock color="#505050" />
                  </span>
                </span>
                <div>
                  <p className="ff_poppins font-normal sm:font-medium text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-[21px] xl:leading-[27px] text-black ">
                    Offer TAT
                  </p>
                  <p className="text-[#5e57eb] ff_poppins font-normal xl:font-medium text-xs sm:text-sm md:text-base xl:text-xl leading-[18px] xl:leading-[24px] mt-1 capitalize">
                    {items.offer_tat ? items.offer_tat : "N/A"} Days
                  </p>
                </div>
              </div>
            </div>
            <Link
              href={`/all-courses/${items?.college_slug}`}
              className="font-semibold cursor-pointer ff_poppins text-sm xl:text-base 3xl:text-lg rounded-xl text-center hover:scale-105 ease-linear duration-300 mt-6 absolute bottom-7 sm:bottom-7 xl:bottom-14 left-1/2 -translate-x-1/2 text-nowrap"
            >
              <span className="gradientBorderWithRadios px-6 sm:px-7 lg:px-10 xl:px-12 py-[14px] sm:py-3">
                Explore Courses
              </span>
            </Link>
          </div>
          <div className="w-full hidden xl:flex absolute bottom-5 right-1/2 translate-x-1/2 items-center justify-center p-2 group-hover:bottom-[100%] group-hover:opacity-0 duration-300 ease-in-out">
            <h4 className="font-semibold text-black text-base sm:text-[18px] md:text-[20px] xl:text-[24px] break-words xl:leading-9 text-center">
              {items?.college_name}
            </h4>
          </div>
        </Link>
      )}
    </div>
  );
}
